import React, {Component} from 'react';
import { connect } from 'react-redux';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import LANGUAGE_CONTROLLER from '../../../controllers/languages';
import { SSelect } from '@avalara/skylab-sdk/react';

const log = new Logger('FILING_REPORT_TYPE_SELECTOR', LOG_LEVELS.DEBUG);

class FilingReportTypeSelector extends Component {

    UNSAFE_componentWillMount() {
        log.debug('FilingReportTypeSelector_componentWillMount');
        this.props.onPageLoad();
    }

    componentDidMount(){
        log.debug('FilingReportTypeSelector: componentDidMount()');
    }

    render() {
        log.debug('FilingReportTypeSelector');
        log.debug('render(): ', this.props);
        if (this.props.flowTypes) {
            // Create options list for SSelect
            const optionsList = this.props.flowTypes.map((flowType, key) => ({
                key: key.toString(),
                value: flowType,
                label: LANGUAGE_CONTROLLER.format(this.props.languageString, flowType),
                selected: this.props.selectValue === flowType
            }));

            return (
                <fieldset>
                    <SSelect
                        inputId="filing-report-type-selector"
                        optionsList={optionsList}
                        multiple={false}
                        onS-select={(e) => {
                            // Create a synthetic event that matches the original onChange signature
                            const syntheticEvent = {
                                target: { value: e.detail.item.value }
                            };
                            this.props.onChange(syntheticEvent);
                        }}
                    />
                </fieldset>
            );
        }
        return (<div></div>);
    }
}

function matchDispatchToProps(dispatch) {
    log.debug('matchDispatchToProps: ', dispatch);
    return {
        onPageLoad: () => {
            log.debug('onPageLoad: ');
        }
    }
}


export default connect(null, matchDispatchToProps)(FilingReportTypeSelector);
